import React from "react";
import PropTypes from "prop-types";

import { INVOICES_PAGE, DOWNGRADE_PATH } from "js/data/links";

import Link from "core/Link";
import BodyText from "core/BodyText";
import StripePortalLink from "frontend/components/core/StripePortalLink";
import { Section, Title, SpacedBlock } from "./styles";

import { apolloClient } from "js/apollo/apollo-client";

const SubscriptionLinks = ({
    activeUsername,
    email,
    csrf,
    paypalId,
    stripeId,
    organizationId = null,
    showBackupPaymentCopy = false,
}) => {
    // TODO: Grab environment from redux "config" slice once no longer on legacy page
    const isProduction =
        typeof window === "object" &&
        window._nounConfig.environment === "production";

    return (
        <Section>
            <Title>Manage Subscription</Title>
            {!paypalId && showBackupPaymentCopy && (
                <>
                    <SpacedBlock>
                        <BodyText>
                            If your primary payment method fails, valid back-up payment
                            methods associated with your account will be tried.
                        </BodyText>
                    </SpacedBlock>
                    <SpacedBlock>
                        <StripePortalLink
                            client={apolloClient}
                            organizationId={organizationId}
                            showTooltip={false}
                            renderAs="link"
                        >
                            Add a backup payment method
                        </StripePortalLink>
                    </SpacedBlock>
                </>
            )}
            <SpacedBlock>
                <Link
                    disableVisitedStyle
                    href={INVOICES_PAGE.replace(":username", activeUsername)}
                >
                    Subscription billing history
                </Link>
            </SpacedBlock>
            <SpacedBlock>
                <Link
                    disableVisitedStyle
                    href="https://thenounproject.zendesk.com/hc/en-us/sections/200144558-NounPro-NounTeam-Accounts"
                    target="_blank"
                >
                    Subscription FAQs
                </Link>
            </SpacedBlock>
            <SpacedBlock>
                {paypalId ? (
                    <Link
                        disableVisitedStyle
                        href={`https://${
                            isProduction ? "www" : "sandbox"
                        }.paypal.com/myaccount/autopay`}
                        target="_blank"
                    >
                        Review or update subscription at PayPal
                    </Link>
                ) : (
                    <Link
                        disableVisitedStyle
                        id="cancel_pro_sub_button"
                        data-csrf={csrf}
                        data-stripe={stripeId}
                        data-email={email}
                        href={DOWNGRADE_PATH.replace(
                            ":username",
                            activeUsername
                        )}
                    >
                        Cancel subscription
                    </Link>
                )}
            </SpacedBlock>
        </Section>
    );
};

SubscriptionLinks.propTypes = {
    activeUsername: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    csrf: PropTypes.string.isRequired,
    paypalId: PropTypes.string,
    stripeId: PropTypes.string,
    organizationId: PropTypes.number,
    showBackupPaymentCopy: PropTypes.bool,
};

export default SubscriptionLinks;
